import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';

const Rep_sftp = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("D");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [reportType, setReportType] = useState("I");
    const [amount, setAmount] = useState("1000000");
    const [filterBtTransaction, setFilterBtTransaction] = useState(true);
    const [filterPan, setFilterPan] = useState(true);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_SFTP'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems.length === 0) || (amount === "")) {
            msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedItems.length === 0) ? "Please select atleast one location." : '');
            msg[i++] = ((amount === "") ? "Please enter Amount." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                fromDate: Common.dateDMY(fromDate),
                toDate: Common.dateDMY(toDate),
                type: generateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                reportType: reportType,
                amount: amount,
                filterBtTransaction: filterBtTransaction,
                filterPan: filterPan

            };
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apiRepSftp, "post", [sid, "download", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiRepSftp, [sid, "view", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>SFTP Report</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    {/* <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Report Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={reportType} onChange={e => setReportType(e.target.value)}
                                required>
                                <option value="I">Individual</option>
                                <option value="C">Corporate</option>
                                <option value="D">Dealer</option>
                            </Form.Select>
                        </Form.Group>
                    </Col> */}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" placeholder='Amount' value={amount} onChange={e => Common.validateNumValue(e.target.value, setAmount)} />
                        </Form.Group>
                    </Col>
                    {/* <Row>
                        <Row><h4>Report Period</h4></Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown

                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row> */}
                    {/* <Row><h4>Report View</h4></Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Row>
                        {reportType === 'I' ?
                            <Col className="col-md-1 col-1">
                                <Form.Check
                                    size='sm'
                                    type="checkbox"
                                    label="Including BT Transactions"
                                    checked={filterBtTransaction}
                                    onChange={() => setFilterBtTransaction(!filterBtTransaction)}
                                />
                            </Col> : null
                        }
                    </Row> */}
                    {/* <Row>
                        <Col className="col-md-1 col-1">
                            <Form.Check
                                size='sm'
                                type="checkbox"
                                label="Consolidate on PAN"
                                checked={filterPan}
                                onChange={() => setFilterPan(!filterPan)}
                            />
                        </Col>
                    </Row> */}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_sftp;